import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f4cc2dac&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f4cc2dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cc2dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4cc2dac')) {
      api.createRecord('f4cc2dac', component.options)
    } else {
      api.reload('f4cc2dac', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f4cc2dac&scoped=true&", function () {
      api.rerender('f4cc2dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25ItO00WqRiv2/JS/comp/DocBox.vue"
export default component.exports